import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQueryWithReauth } from '@/services';
import { PaginatedRequest, PaginatedResponse } from '@/types';
import { API_BUSINESS_URL } from '@/utils';

import { Neighborhood, NeighborhoodFilters } from '../models';

const neighborhoodService = createApi({
  reducerPath: 'neighborhoodService',
  baseQuery: createBaseQueryWithReauth(`${API_BUSINESS_URL}`),
  tagTypes: ['Neighborhood'] as const,
  endpoints: (builder) => ({
    getNeighborhoods: builder.query<
      PaginatedResponse<Neighborhood>,
      {
        paginated: PaginatedRequest;
        filters?: NeighborhoodFilters;
        search?: string;
      }
    >({
      query: ({ paginated, filters, search }) => {
        const params: Record<string, any> = {
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
        };

        if (search && search.trim() !== '') {
          params.search = search.trim();
        } else {
          if (filters?.name) params.name = filters.name;
          if (filters?.cityId) params.cityId = filters.cityId;
        }

        return {
          url: '/neighborhoods',
          params,
        };
      },
      providesTags: ['Neighborhood'],
    }),
    getNeighborhoodById: builder.query<
      Neighborhood,
      { neighborhoodId: string }
    >({
      query: ({ neighborhoodId }) => ({
        url: `/neighborhoods/${neighborhoodId}`,
      }),
      providesTags: ['Neighborhood'],
    }),
  }),
});

export default neighborhoodService;
export const { useGetNeighborhoodsQuery, useGetNeighborhoodByIdQuery } =
  neighborhoodService;
